import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Payment } from '@payment/const';

@Component({
  selector: 'sd-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPaymentListComponent {
  @Input() payments: Payment[];

  @Output() addPayment = new EventEmitter<void>();
  @Output() removePayment = new EventEmitter<Payment>();
}
